// extracted by mini-css-extract-plugin
export var deleteModal = "_rv-0";